/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import CustomButton from "views/components/common/button/CustomButton";
import Invoiceedit from "../../../assets/images/invoice-edit.svg";
import Invoicenotes from "../../../assets/images/invoice-notes.svg";
import InvoicenotesCompleted from "../../../assets/images/notes-tick.svg";
import React from "react";
import { Tooltip, notification } from "antd";
import { Collapse, Modal, Spin } from "antd";
import drag from "../../../assets/images/drag.svg";
import trash from "../../../assets/images/delete.svg";
import downarrow from "../../../assets/images/black-down-arrow.svg";
import uparrow from "../../../assets/images/black-up-arrow.svg";
import edit from "../../../assets/images/action_edit.svg";
import backarrow from "../../../assets/images/backarrow.svg";
import addTreatmentIcon from "../../../assets/images/add-treatment.svg";
import modalNote from "../../../assets/images/modal-note.svg";
import { Input } from "antd";
import ImageList from "./ImageViewer";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { Reorder, getItemStyle, handleDownload } from "./utils";
import LineItem from "./LineItem";
import axios from "axios";
import { v4 as uuid } from "uuid";
import { useTranslation } from "react-i18next";
import CustomModal from "views/components/common/custommodal/CustomModal";
import { forceLogout } from "utilities/HttpUtility";
import environment from "environment";

const FEEDBACK_METADATA_FIELDS = [
  "feedback_original_category",
  "feedback_original_exclusion_subcode",
  "feedback_change_reason",
  "feedback_change_context",
];

const normalizeFeedbackValue = (value) => {
  if (typeof value === "string") return value.trim();
  if (value === null || value === undefined) return "";
  return String(value).trim();
};

const hasCategoryOverride = (item = {}) => {
  const currentCategory = normalizeFeedbackValue(item?.category ?? item?.Category);
  const currentExclusionSubcode = normalizeFeedbackValue(
    item?.exclusion_subcode ??
      item?.exclusionSubcode ??
      item?.exclusionSubCode ??
      item?.exclusion
  );
  const originalCategory = normalizeFeedbackValue(item?.feedback_original_category);
  const originalExclusionSubcode = normalizeFeedbackValue(
    item?.feedback_original_exclusion_subcode
  );

  return (
    currentCategory !== originalCategory ||
    currentExclusionSubcode !== originalExclusionSubcode
  );
};

const syncItemFeedbackState = (item = {}) => {
  if (!hasCategoryOverride(item)) {
    return {
      ...item,
      feedback_change_reason: "",
      feedback_change_context: "",
    };
  }

  return item;
};

const createLineItemWithFeedbackSnapshot = (item = {}) =>
  syncItemFeedbackState({
    ...item,
    key: item?.key || uuid(),
    feedback_original_category: normalizeFeedbackValue(item?.category ?? item?.Category),
    feedback_original_exclusion_subcode: normalizeFeedbackValue(
      item?.exclusion_subcode ??
        item?.exclusionSubcode ??
        item?.exclusionSubCode ??
        item?.exclusion
    ),
    feedback_change_reason: "",
    feedback_change_context: "",
  });

const prepareInvoiceForEditor = (invoiceDetails = {}) => ({
  ...invoiceDetails,
  extracted_invoice_data: (invoiceDetails?.extracted_invoice_data || []).map(
    (pageData) => ({
      ...pageData,
      treatments: (pageData?.treatments || []).map((treatment) => ({
        ...treatment,
        key: treatment?.key || uuid(),
        Items: (treatment?.Items || []).map(createLineItemWithFeedbackSnapshot),
      })),
    })
  ),
});

const cloneInvoiceData = (invoiceDetails) =>
  invoiceDetails ? JSON.parse(JSON.stringify(invoiceDetails)) : invoiceDetails;

const stripFeedbackMetadataFromItem = (item = {}) => {
  const sanitizedItem = { ...item };

  FEEDBACK_METADATA_FIELDS.forEach((fieldName) => {
    delete sanitizedItem[fieldName];
  });

  return sanitizedItem;
};

const prepareInvoiceUpdatePayload = (invoiceDetails = {}) => ({
  ...invoiceDetails,
  extracted_invoice_data: (invoiceDetails?.extracted_invoice_data || []).map(
    (pageData) => ({
      ...pageData,
      treatments: (pageData?.treatments || []).map((treatment) => ({
        ...treatment,
        Items: (treatment?.Items || []).map(stripFeedbackMetadataFromItem),
      })),
    })
  ),
});


const Invoice = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const [extractionId, setExtractionId] = useState(null);
  const [initialInvoiceData, setInitialInvoiceData] = useState(null);
  const [invoiceData, setInvoiceData] = useState(null);
  const [selectedPage, setSelectedPage] = useState(1);
  const [images, setImages] = useState(null);
  const [loading, setLoading] = useState(false);
  const [confirmationPopup, setConfirmationPopup] = useState({
    isShow: false,
    type: null,
    treatmentKey: null,
    itemKey: null,
    assigned_to: null,
  });
  const [isNotesModalVisible, setIsNotesModalVisible] = useState(false);
  const [notes, setNotes] = useState(null);
  const [documentId, setDocumentId] = useState(null);
  const [sumValues, setSumValues] = useState(null);
  const [isCollapseActive, setIsCollapseActive] = useState(false);
  const [isSumManual, setSumManual] = useState(false);
  const [isOwner, setIsOwner] = useState(false);
  const [buttonName, setButtonName] = useState("Delete");


  const handleSwitchManualSum = () => {
    setSumManual((prevState) => !prevState);
  };

  const toggleCollapse = (e) => {
    setIsCollapseActive((prevState) => !prevState);
  };
  const openNotesModel = () => {
    setIsNotesModalVisible(true);
  };

  const handleNotesModalOk = () => {
    addNotes();
    setIsNotesModalVisible(false);
  };

  const addNotes = async () => {
    let payload = {};
    let endpoint = `${environment.baseApi}/document/note/${documentId}`;
    payload = {
      notes: notes,
    };
    const headers = {
      "Content-Type": "application/json",
    };

    const token = sessionStorage.getItem("authToken");

    if (token) {
      headers.Authorization = token;
    }

    try {
      const response = await axios.post(endpoint, payload, {
        headers,
      });
      setNotes(response?.data?.result?.result);
      notification.success({
        message: t("noteSaved"),
      });
    } catch (err) {
      if (err.response.status === 401) {
        notification.error({
          message: t("accessDenied"),
          description: t("tokenExpired"),
        });
        forceLogout(err.response.status);
      } else {
        notification.error({
          message: "Document List Error",
          description: err,
        });
      }
    }
  };
  const handleNotesModalCancel = () => {
    notification.info({
      message: t("noteNotSaved"),
    });
    setIsNotesModalVisible(false);
    setNotes(invoiceData?.notes);
  };

  const handleNotesChange = (e) => {
    setNotes(e.target.value);
  };

  const handleExcelDownload = async () => {
    const token = sessionStorage.getItem("authToken");

    const headers = {
      "Content-Type": "application/json",
    };
    if (token) {
      headers.Authorization = token;
    }

    let endpoint = `${environment.baseApi}/document/export/${documentId}`;
    try {
      const response = await axios.get(endpoint, {
        headers,
      });

      if (response.status === 200) {
        handleDownload(response?.data?.result?.sas_document_link);

        if (environment.APP_ENVIRONMENT !== 'alabusTesting' && environment.APP_ENVIRONMENT !== 'eponaDevelopment' && environment.APP_ENVIRONMENT !== 'eponaTesting' && environment.APP_ENVIRONMENT !== 'eponaProduction') {
          // Disabling download excel for alabus client
          if (response?.data?.result?.sas_excel_link) {
            setTimeout(async () => {
              await handleDownload(response?.data?.result?.sas_excel_link);
            }, 3000);
          }
        }
      }
    } catch (err) {
      if (err.response.status === 401) {
        notification.error({
          message: t("accessDenied"),
          description: t("tokenExpired"),
        });
        forceLogout(err.response.status);
      } else if (err.response.status === 400) {
        notification.error({
          message: t("notAssigned"),
        });
      } else {
        notification.error({
          message: "Something went wrong",
        });
      }
    }
  };

  useEffect(() => {
    const documentId = location.pathname.split("/")[2];

    setExtractionId(documentId);
    getDocument(documentId);
    setDocumentId(documentId);
  }, []);

  const getDocument = async (documentId) => {
    setLoading(true);
    const token = sessionStorage.getItem("authToken");

    const headers = {
      "Content-Type": "application/json",
    };
    if (token) {
      headers.Authorization = token;
    }

    let endpoint = `${environment.baseApi}/document/${documentId}`;

    try {
      const response = await axios.get(endpoint, {
        headers,
      });

      const invoiceDetails = prepareInvoiceForEditor(response?.data?.result);

      setInvoiceData(invoiceDetails);
      setInitialInvoiceData(cloneInvoiceData(invoiceDetails));

      const updatedValues = {};

      for (let key in invoiceDetails.total_sum_values) {
        if (invoiceDetails.total_sum_values.hasOwnProperty(key)) {
          let value = invoiceDetails.total_sum_values[key];

          value = parseFloat(Number(value)?.toFixed(2));

          updatedValues[key] = value;
        }
      }

      setSumValues(updatedValues);
      setNotes(invoiceDetails.notes);
      setSumManual(invoiceDetails?.total_sum_values?.is_manual);
      const invoiceImages = response?.data?.result?.extracted_invoice_data?.map(
        (item) => {
          return { id: item.page_no, image_url: item.sasUrl };
        }
      );

      setImages(invoiceImages);

      const logged_user = sessionStorage.getItem("user_id");
      if (logged_user === response.data.result.assigned_to) {
        setIsOwner(true);
      }
      setLoading(false);
    } catch (err) {
      if (err.response.status === 401) {
        notification.error({
          message: t("accessDenied"),
          description: t("tokenExpired"),
        });
        forceLogout(err.response.status);
      } else {
        notification.error({
          message: "Document List Error",
          description: err,
        });
      }
    }
    setLoading(false);
  };

  const getInitialDocument = async (documentId) => {
    setLoading(true);
    const token = sessionStorage.getItem("authToken");
    const headers = {
      "Content-Type": "application/json",
    };
    if (token) {
      headers.Authorization = token;
    }

    let endpoint = `${environment.baseApi}/document/initial/${documentId}`;
    try {
      const response = await axios.get(endpoint, {
        headers,
      });
      setLoading(false);

      if (response.status === 200) {
        notification.success({
          message: t("DocumentResetToInitial"),
        });
      }

      const invoiceDetails = prepareInvoiceForEditor({
        ...response?.data?.result,
        extracted_invoice_data: response?.data?.result?.extracted_invoice_data_initial,
        general_information: response?.data?.result?.general_information_initial,
        total_sum_values: response?.data?.result?.total_sum_values_initial,
      });

      setInvoiceData(invoiceDetails);
      setInitialInvoiceData(cloneInvoiceData(invoiceDetails));
      setSumValues(invoiceDetails?.total_sum_values);
      setNotes(invoiceDetails.notes);
      const invoiceImages = response?.data?.result?.extracted_invoice_data?.map(
        (item) => {
          return { id: item.page_no, image_url: item.sasUrl };
        }
      );

      setImages(invoiceImages);
    } catch (err) {
      if (err.response.status === 401) {
        notification.error({
          message: t("accessDenied"),
          description: t("tokenExpired"),
        });
        forceLogout(err.response.status);
      } else {
        notification.error({
          message: err.response.data.error.msg,
        });
      }
      setLoading(false);
    }
  };

  const onDragEnd = (result) => {
    const { source, destination, type } = result;

    if (!destination) {
      return;
    }

    if (type === "treatment") {
      setInvoiceData((prevState) => ({
        ...prevState,
        extracted_invoice_data: prevState.extracted_invoice_data.map(
          (pageData, index) => {
            if (index === selectedPage - 1) {
              // Reorder treatments
              let reordered = Reorder(
                pageData.treatments,
                source.index,
                destination.index
              );
              // Update treatment_order based on new order
              reordered = reordered.map((treatment, idx) => ({
                ...treatment,
                treatment_order: idx + 1,
              }));
              return {
                ...pageData,
                treatments: reordered,
              };
            }
            return pageData;
          }
        ),
      }));
    } else {
      setInvoiceData((prevState) => ({
        ...prevState,
        extracted_invoice_data: prevState.extracted_invoice_data.map(
          (pageData, index) => {
            if (index === selectedPage - 1) {
              const updatedTreatments = pageData.treatments.map((treatment) => {
                if (treatment.key === source.droppableId) {
                  return {
                    ...treatment,
                    Items: Reorder(
                      treatment.Items,
                      source.index,
                      destination.index
                    ),
                  };
                }
                return treatment;
              });

              return {
                ...pageData,
                treatments: updatedTreatments,
              };
            }
            return pageData;
          }
        ),
      }));
    }
  };

  const handleOnChangePage = (page) => {
    setSelectedPage(page);
  };

  const handleOnClickAssign = () => {
    if (isOwner) {
      setConfirmationPopup({
        isShow: true,
        type: "revoke",
        treatmentKey: null,
        itemKey: null,
        assigned_to: null,
      });
    } else {
      setConfirmationPopup({
        isShow: true,
        type: "assign",
        treatmentKey: null,
        itemKey: null,
        assigned_to: invoiceData.assigned_user,
      });
    }
  };

  const handleOnAssignOwner = async () => {
    let notificationMessage;
    if (isOwner) {
      notificationMessage = t("revokeDocument");
    } else {
      notificationMessage = t("successDocumentProgressStatus");
    }
    const token = sessionStorage.getItem("authToken");

    const headers = {
      "Content-Type": "application/json",
    };
    if (token) {
      headers.Authorization = token;
    }
    let endpoint = `${environment.baseApi}/document/status/${documentId}`;
    try {
      const response = await axios.patch(
        endpoint,
        {},
        {
          headers,
        }
      );

      if (response.status === 200) {
        notification.success({
          message: notificationMessage,
        });
        setIsOwner(!isOwner);
        getDocument(documentId);
      }
    } catch (err) {
      if (err.response.status === 401) {
        notification.error({
          message: t("accessDenied"),
          description: t("tokenExpired"),
        });
        forceLogout(err.response.status);
      } else {
        notification.error({
          message: err.response.data.error.msg,
        });
      }
    }
  };

  const addTreatment = () => {
    setInvoiceData((prevState) => ({
      ...prevState,
      extracted_invoice_data: prevState.extracted_invoice_data.map(
        (pageData, index) => {
          if (index === selectedPage - 1) {
            return {
              ...pageData,
              treatments: [
                ...pageData.treatments,
                {
                  treatment_order:
                    prevState.extracted_invoice_data[selectedPage - 1]
                      .treatments.length + 1,
                  "Pet Name": "",
                  "Treatment Date": "",
                  "Diagnose": "",
                  key: uuid(),
                  Items: [
                    createLineItemWithFeedbackSnapshot({
                      "Item Name": "",
                      "Item Quantity": "",
                      "Item Price": "",
                      VAT: null,
                      item_order: 1,
                    }),
                  ],
                  sub_total: 0,
                },
              ],
            };
          }
          return pageData;
        }
      ),
    }));
  };

  const removeTreatment = (treatmentKey) => {
    setInvoiceData((prevState) => ({
      ...prevState,
      extracted_invoice_data: prevState.extracted_invoice_data.map(
        (pageData, index) => {
          if (index === selectedPage - 1) {
            // Remove the treatment and update treatment_order
            const filteredTreatments = pageData.treatments.filter(
              (treatment) => treatment.key !== treatmentKey
            );
            const reorderedTreatments = filteredTreatments.map((treatment, idx) => ({
              ...treatment,
              treatment_order: idx + 1,
            }));
            return {
              ...pageData,
              treatments: reorderedTreatments,
            };
          }
          return pageData;
        }
      ),
    }));
  };

  const addItemToTreatment = (treatmentKey) => {
    setInvoiceData((prevState) => ({
      ...prevState,
      extracted_invoice_data: prevState?.extracted_invoice_data?.map(
        (pageData, index) => {
          if (index === selectedPage - 1) {
            return {
              ...pageData,
              treatments: pageData.treatments.map((treatment) => {
                if (treatment.key === treatmentKey) {
                  // Calculate the next item_order
                  const items = treatment.Items || [];
                  const maxOrder = items.length > 0
                    ? Math.max(...items.map(item => item.item_order || 0))
                    : 0;
                  return {
                    ...treatment,
                    Items: [
                      ...items,
                      createLineItemWithFeedbackSnapshot({
                        "Item Name": "",
                        "Item Quantity": "",
                        "Item Price": "",
                        VAT: null,
                        isNew: true,
                        item_order: maxOrder + 1,
                      }),
                    ],
                  };
                }
                return treatment;
              }),
            };
          }
          return pageData;
        }
      ),
    }));
  };

  const updateInvoiceItem = (item, inputName, newValue) => {
    const nextItem = {
      ...item,
      [inputName]: newValue,
    };

    if (inputName === "feedback_change_reason" && !newValue) {
      nextItem.feedback_change_context = "";
    }

    return syncItemFeedbackState(nextItem);
  };

  const updateTreatmentItems = (treatment, itemKey, inputName, newValue) => ({
    ...treatment,
    Items: treatment.Items.map((item) => {
      if (item.key !== itemKey) {
        return item;
      }

      if (inputName === "Item Price") {
        const regex = /^-?\d*\.?\d{0,2}$/;

        if (!regex.test(newValue)) {
          return item;
        }
      }

      return updateInvoiceItem(item, inputName, newValue);
    }),
  });

  const removeItemFromTreatment = (treatmentKey, itemKey) => {
    setInvoiceData((prevState) => ({
      ...prevState,
      extracted_invoice_data: prevState.extracted_invoice_data.map(
        (pageData, index) => {
          if (index === selectedPage - 1) {
            return {
              ...pageData,
              treatments: pageData.treatments.map((treatment) => {
                if (treatment.key === treatmentKey) {
                  // Remove the item and update item_order
                  const filteredItems = treatment.Items.filter(
                    (item) => item.key !== itemKey
                  );
                  const reorderedItems = filteredItems.map((item, idx) => ({
                    ...item,
                    item_order: idx + 1,
                  }));
                  return {
                    ...treatment,
                    Items: reorderedItems,
                  };
                }
                return treatment;
              }),
            };
          }
          return pageData;
        }
      ),
    }));
  };

  const updateTreatmentContent = (
    treatmentKey,
    itemKey,
    inputName,
    newValue
  ) => {
    setInvoiceData((prevState) => ({
      ...prevState,
      extracted_invoice_data: prevState.extracted_invoice_data.map(
        (pageData, pageIndex) => {
          if (pageIndex === selectedPage - 1) {
            return {
              ...pageData,
              treatments: pageData.treatments.map((treatment) => {
                if (treatment.key === treatmentKey) {
                  if (
                    inputName === "Pet Name" ||
                    inputName === "Treatment Date" ||
                    inputName === "Diagnose"
                  ) {
                    return {
                      ...treatment,
                      [inputName]: newValue,
                    };
                  } else if (inputName === "Item Price") {
                    return updateTreatmentItems(
                      treatment,
                      itemKey,
                      inputName,
                      newValue
                    );
                  } else {
                    return updateTreatmentItems(
                      treatment,
                      itemKey,
                      inputName,
                      newValue
                    );
                  }
                }
                return treatment;
              }),
            };
          }
          return pageData;
        }
      ),
    }));
  };

  const onChangeGenreralInfo = (e) => {
    const { name, value } = e.target;

    setInvoiceData((prevState) => ({
      ...prevState,
      general_information: {
        ...prevState.general_information,
        [name]: value,
      },
    }));
  };

  const handleKeyDown = (e) => {
    const invalidChars = [
      "+",
      "e",
      "E",
      ",",
      " ",
      "!",
      "@",
      "#",
      "$",
      "%",
      "^",
      "&",
      "*",
      "(",
      ")",
      "_",
      "=",
      "{",
      "}",
      "[",
      "]",
      "|",
      "\\",
      ":",
      ";",
      "'",
      '"',
      "<",
      ">",
      "?",
      "/",
      "~",
      "`",
      "a",
      "b",
      "c",
      "d",
      "f",
      "g",
      "h",
      "i",
      "j",
      "k",
      "l",
      "m",
      "n",
      "o",
      "p",
      "q",
      "r",
      "s",
      "t",
      "u",
      "v",
      "w",
      "x",
      "y",
      "z",
      "A",
      "B",
      "C",
      "D",
      "F",
      "G",
      "H",
      "I",
      "J",
      "K",
      "L",
      "M",
      "N",
      "O",
      "P",
      "Q",
      "R",
      "S",
      "T",
      "U",
      "V",
      "W",
      "X",
      "Y",
      "Z",
    ];
    if (invalidChars.includes(e.key)) {
      e.preventDefault();
    }
  };

  const handleOnChangeSumValues = (e) => {
    let value = e.target.value.trim();
    const regex = /^-?\d*\.?\d{0,2}$/;

    if (regex.test(value)) {

      setSumValues((preState) => {
        return {
          ...preState,
          [e.target.name]: value,
        };
      });
    }
  };
  const calculateSubTotal = (treatment) => {
    const subTotal = treatment.Items.reduce((acc, curr) => {
      const price = parseFloat(curr["Item Price"]);
      if (!isNaN(price)) {
        return acc + price;
      }
      return acc;
    }, 0);

    return subTotal.toFixed(2);
  };

  const calculateTotalSum = () => {
    let totalItemsPrice = 0;

    invoiceData?.extracted_invoice_data?.forEach((pageData) => {
      pageData.treatments.forEach((treatment) => {
        treatment.Items.forEach((item) => {
          const price = parseFloat(item["Item Price"]);
          if (!isNaN(price)) {
            totalItemsPrice += price;
          }
        });
      });
    });

    return totalItemsPrice.toFixed(2);
  };

  const calculateManualSum = () => {
    return sumValues?.calculated_total_sum_after_discount_manual;
  };

  const calculateAutoSumAfterDiscount = () => {
    const discountAmount = Math.abs(parseFloat(sumValues?.total_discount_amount) || 0); 
    const sum = calculateTotalSum() - discountAmount;
  
    const result = isNaN(sum) ? null : parseFloat(sum.toFixed(2));
  
    return result;
  };
  
  
  

  const handleOnReset = () => {
    setInvoiceData(cloneInvoiceData(initialInvoiceData));
  };

  const handleResetConfirmationPopup = (type, treatmentKey, itemKey) => {
    setButtonName("reset");
    setConfirmationPopup({
      isShow: true,
      type,
      treatmentKey: treatmentKey || null,
      itemKey: itemKey || null,
    });
  };

  const handleConfirmationPopup = (type, treatmentKey, itemKey) => {
    setConfirmationPopup({
      isShow: true,
      type,
      treatmentKey: treatmentKey || null,
      itemKey: itemKey || null,
    });
  };

  const handleOnDeleteConfirmation = () => {
    if (confirmationPopup.type === "treatment") {
      removeTreatment(confirmationPopup.treatmentKey);
    } else if (confirmationPopup.type === "line-item") {
      removeItemFromTreatment(
        confirmationPopup.treatmentKey,
        confirmationPopup.itemKey
      );
    } else if (confirmationPopup.type === "resetToInitial") {
      getInitialDocument(documentId);
    } else if (
      confirmationPopup.type === "assign" ||
      confirmationPopup.type === "revoke"
    ) {
      handleOnAssignOwner();
    } else if (confirmationPopup.type === "reset") {
      handleOnReset();
    }
    setConfirmationPopup({
      isShow: false,
      type: null,
      treatmentKey: null,
      itemKey: null,
    });
  };

  const handleOnDeleteCancel = () => {
    setConfirmationPopup({
      isShow: false,
      type: null,
      key: null,
    });
  };

  const handleOnUpdate = async (invoiceData, sumValues) => {
    const reqData = prepareInvoiceUpdatePayload(invoiceData);
    const reqSumValues = { ...sumValues };

    // Convert numeric values to float
    reqSumValues.invoice_total_sum_price_without_vat = parseFloat(reqSumValues.invoice_total_sum_price_without_vat) || 0;
    reqSumValues.invoice_total_sum_price_with_vat = parseFloat(reqSumValues.invoice_total_sum_price_with_vat) || 0;
    reqSumValues.calculated_total_sum = parseFloat(reqSumValues.calculated_total_sum) || 0;
    reqSumValues.total_discount_amount = parseFloat(reqSumValues.total_discount_amount) || 0;
    reqSumValues.calculated_total_sum_after_discount = parseFloat(reqSumValues.calculated_total_sum_after_discount) || 0;
    reqSumValues.calculated_total_sum_manual = parseFloat(reqSumValues.calculated_total_sum_manual) || 0;
    reqSumValues.calculated_total_sum_after_discount_manual = parseFloat(reqSumValues.calculated_total_sum_after_discount_manual) || 0;

    reqData.total_sum_values = reqSumValues;
    reqData.total_sum_values.is_manual = isSumManual;

    if (!isSumManual) {
      reqData.total_sum_values.calculated_total_sum = parseFloat(calculateTotalSum()) || 0; 
      reqData.total_sum_values.calculated_total_sum_after_discount = parseFloat(
        (calculateTotalSum() - Math.abs(parseFloat(sumValues?.total_discount_amount) ||0))
          .toFixed(2) 
      ); 
    }

    let endpoint = `${environment.baseApi}/document/update/${extractionId}`;
    const headers = {
      "Content-Type": "application/json",
    };

    const token = sessionStorage.getItem("authToken");

    if (token) {
      headers.Authorization = token;
    }
    setLoading(true);

    try {
      const response = await axios.put(endpoint, reqData, {
        headers,
      });
      setLoading(false);
      if (response.status === 200) {
        notification.success({
          message: t("UpdateSuccess"),
        });

        getDocument(extractionId);
      }
    } catch (err) {
      if (err.response.status === 401) {
        notification.error({
          message: t("accessDenied"),
          description: t("tokenExpired"),
        });
        forceLogout(err.response.status);
      } else {
        notification.error({
          message: err.response.data.error.msg,
        });
      }
      setLoading(false);
    }
  };

  const handleOnBack = () => {
    navigate("/invoice");
  };
  const normalizeDecimal = (value) => {
    let valueStr = value.toString();
    if (valueStr.includes(".")) {
      let parts = valueStr.split(".");
      if (parts[1].length === 1) {
        valueStr = `${parts[0]}.${parts[1]}0`;
      }
    }
    return valueStr;
  };

  const verifyTotal = () => {
    const discountValue = Math.abs(parseFloat(sumValues?.total_discount_amount) || 0);

    let afterDiscount =
      isSumManual === false
        ? calculateTotalSum() - discountValue
        : calculateManualSum();

    let normalizedAfterDiscount = normalizeDecimal(afterDiscount);

    let normalizedInvoiceTotalWithVat = normalizeDecimal(
      sumValues?.invoice_total_sum_price_with_vat || 0
    );
    let normalizedInvoiceTotalWithoutVat = normalizeDecimal(
      sumValues?.invoice_total_sum_price_without_vat || 0
    );

    if (
      normalizedAfterDiscount === normalizedInvoiceTotalWithVat ||
      normalizedAfterDiscount === normalizedInvoiceTotalWithoutVat
    ) {
      return true;
    }
    return false;
  };

  const general_information = [
    {
      key: "1",
      label: (
        <span className="dark-text fs18 poppins-medium d-inline-block">
          {t("generalInformation")}
        </span>
      ),
      children: (
        <div>
          <div className="row mt20">
            <div className="col-md-4 col-12">
              <label className="time-gray fs12 poppins-medium mb5">
                {t("invoiceDate")}
              </label>
              <Input
                name={"Invoice Date"}
                value={invoiceData?.general_information?.["Invoice Date"] || ""}
                onChange={(e) => onChangeGenreralInfo(e)}
                className={
                  invoiceData?.general_information?.["Invoice Date"]?.trim() ===
                    "" ||
                  invoiceData?.general_information?.["Invoice Date"] === null
                    ? "bg-invoiceorange"
                    : ""
                }
                placeholder={t("invoiceDate")}
                disabled={!isOwner}
              />{" "}
            </div>
            <div className="col-md-4 col-12">
              <label className="time-gray fs12 poppins-medium mb5">
                {t("invoiceReference")}
              </label>
              <Input
                name={"Invoice Reference"}
                value={invoiceData?.general_information?.["Invoice Reference"]}
                onChange={(e) => onChangeGenreralInfo(e)}
                className={
                  invoiceData?.general_information?.[
                    "Invoice Reference"
                  ]?.trim() === "" ||
                  invoiceData?.general_information?.["Invoice Reference"] ===
                    null
                    ? "bg-invoiceorange"
                    : ""
                }
                placeholder={t("invoiceReference")}
                disabled={!isOwner}
              />{" "}
            </div>
            <div className="col-md-4 col-12">
              <label className="time-gray fs12 poppins-medium mb5">
                {t("language")}
              </label>
              <Input
                name={"invoice_language"}
                value={t(invoiceData?.general_information?.invoice_language?.toLowerCase() || null)}
                onChange={(e) => onChangeGenreralInfo(e)}
                className={
                  invoiceData?.general_information?.invoice_language?.trim() ===
                    "" ||
                  invoiceData?.general_information?.invoice_language === null
                    ? "bg-invoiceorange"
                    : ""
                }
                placeholder={t("language")}
                disabled={!isOwner}
              />
            </div>
          </div>
          <div className="row mt15">
            <div className="col-md-4 col-12">
              <label className="time-gray fs12 poppins-medium mb5">
                {t("vetName")}
              </label>
              <Input
                name={"Vet Name"}
                value={invoiceData?.general_information?.["Vet Name"]}
                onChange={(e) => onChangeGenreralInfo(e)}
                className={
                  invoiceData?.general_information?.["Vet Name"]?.trim() ===
                    "" ||
                  invoiceData?.general_information?.["Vet Name"] === null
                    ? "bg-invoiceorange"
                    : ""
                }
                placeholder={t("vetName")}
                disabled={!isOwner}
              />{" "}
            </div>
            <div className="col-md-4 col-12">
              <label className="time-gray fs12 poppins-medium mb5">
                {t("vetStreet")}
              </label>
              <Input
                name={"vet_street_address"}
                value={invoiceData?.general_information?.["vet_street_address"]}
                onChange={(e) => onChangeGenreralInfo(e)}
                className={
                  invoiceData?.general_information?.[
                    "vet_street_address"
                  ]?.trim() === "" ||
                  invoiceData?.general_information?.["vet_street_address"] ===
                    null
                    ? "bg-invoiceorange"
                    : ""
                }
                placeholder={t("vetStreet")}
                disabled={!isOwner}
              />
            </div>
            <div className="col-md-4 col-12">
             <div className="row">
               <div className="col-md-5">
                 <label className="time-gray fs12 poppins-medium mb5 text-nowrap">
                   {t("postalCode")}
                 </label>
                 <Input
                   name={"vet_zipcode"}
                   value={invoiceData?.general_information?.["vet_zipcode"]}
                   onChange={(e) => onChangeGenreralInfo(e)}
                   className={
                     invoiceData?.general_information?.["vet_zipcode"]?.trim() ===
                       "" ||
                     invoiceData?.general_information?.["vet_zipcode"] === null
                       ? "bg-invoiceorange"
                       : ""
                   }
                   placeholder={t("postalCode")}
                   disabled={!isOwner}
                 />{" "}
               </div>
               <div className="col-md-7">
                 <label className="time-gray fs12 poppins-medium mb5">
                   {t("city")}
                 </label>
                 <Input
                   name={"vet_city"}
                   value={invoiceData?.general_information?.["vet_city"]}
                   onChange={(e) => onChangeGenreralInfo(e)}
                   className={
                     invoiceData?.general_information?.["vet_city"]?.trim() ===
                       "" ||
                     invoiceData?.general_information?.["vet_city"] === null
                       ? "bg-invoiceorange"
                       : ""
                   }
                   placeholder={t("city")}
                   disabled={!isOwner}
                 />{" "}
               </div>
             </div>
            </div>
          </div>
          <div className="row mt15 mb7">
            <div className="col-md-4">
              <label className="time-gray fs12 poppins-medium mb5">
                {t("policyholderName")}
              </label>
              <Input
                name={"Policyholder Name"}
                value={invoiceData?.general_information?.["Policyholder Name"]}
                onChange={(e) => onChangeGenreralInfo(e)}
                className={
                  invoiceData?.general_information?.[
                    "Policyholder Name"
                  ]?.trim() === "" ||
                  invoiceData?.general_information?.["Policyholder Name"] ===
                    null
                    ? "bg-invoiceorange"
                    : ""
                }
                placeholder={t("policyholderName")}
                disabled={!isOwner}
              />{" "}
            </div>
            <div className="col-md-4 col-12">
              <label className="time-gray fs12 poppins-medium mb5">
                {t("policyholderAddress")}
              </label>
              <Input
                name={"policy_holder_street_address"}
                value={
                  invoiceData?.general_information?.[
                    "policy_holder_street_address"
                  ]
                }
                onChange={(e) => onChangeGenreralInfo(e)}
                className={
                  invoiceData?.general_information?.[
                    "policy_holder_street_address"
                  ]?.trim() === "" ||
                  invoiceData?.general_information?.[
                    "policy_holder_street_address"
                  ] === null
                    ? "bg-invoiceorange"
                    : ""
                }
                placeholder={t("policyholderAddress")}
                disabled={!isOwner}
              />
            </div>
            <div className="col-md-4 col-12">
              <div className="row">
                <div className="col-md-5 col-12">
                  <label className="time-gray fs12 poppins-medium mb5 text-nowrap">
                    {t("postalCode")}
                  </label>
                  <Input
                    name={"policy_holder_zipcode"}
                    value={
                      invoiceData?.general_information?.["policy_holder_zipcode"]
                    }
                    onChange={(e) => onChangeGenreralInfo(e)}
                    className={
                      invoiceData?.general_information?.[
                        "policy_holder_zipcode"
                      ]?.trim() === "" ||
                      invoiceData?.general_information?.[
                        "policy_holder_zipcode"
                      ] === null
                        ? "bg-invoiceorange"
                        : ""
                    }
                    placeholder={t("postalCode")}
                    disabled={!isOwner}
                  />{" "}
                </div>
                <div className="col-md-7 col-12">
                  <label className="time-gray fs12 poppins-medium mb5">{t("city")}</label>
                  <Input
                    name={"policy_holder_city"}
                    value={invoiceData?.general_information?.["policy_holder_city"]}
                    onChange={(e) => onChangeGenreralInfo(e)}
                    className={
                      invoiceData?.general_information?.[
                        "policy_holder_city"
                      ]?.trim() === "" ||
                      invoiceData?.general_information?.["policy_holder_city"] ===
                        null
                        ? "bg-invoiceorange"
                        : ""
                    }
                    placeholder={t("city")}
                    disabled={!isOwner}
                  />{" "}
                </div>
              </div>
            </div>
          </div>
        </div>
      ),
    },
  ];
  const calculate_discount = [
    {
      key: "4",
      label: (
        <div className="row">
          <div className="col-md-7 col-6 mx-md-0">
            <span className="fs18 poppins-medium dark-text">
              {t("totalSum")}:
            </span>
          </div>
          <div className="col-md-5 col-6 text-end my-auto pr18 add-item-btn">
            <span
              className={
                verifyTotal()
                  ? `fs18 poppins-semibold total-green`
                  : "fs18 poppins-semibold total-red"
              }
            >
              {!isSumManual
                ? calculateAutoSumAfterDiscount()
                : calculateManualSum()}
            </span>
          </div>
        </div>
      ),
      children: (
        <div>
          <ul className="list-group text-gray-e pe-0 py-2">
            <li className="list-group-item row d-flex text-gray-e border-0">
              <div className="col-6">
                <div className="fs14 text-gray-e my-sm-2 my-0">
                  {t("InvoiceTotalSumPriceWithoutVAT")}:
                </div>
              </div>
              <div className="col-6 text-end pr45">
                <input
                  className="invoice-input"
                  name="invoice_total_sum_price_without_vat"
                  type="text"
                  value={sumValues?.invoice_total_sum_price_without_vat}
                  onChange={(e) => handleOnChangeSumValues(e)}
                  onKeyDown={handleKeyDown}
                  disabled={!isOwner}
                />
              </div>
            </li>
            <li className="list-group-item row d-flex border-0">
              <div className="col-6">
                <div className="fs14 text-gray-e py-sm-2 py-0">
                  {t("InvoiceTotalSumPriceWithVAT")}:
                </div>
              </div>
              <div className="col-6 text-end pr45">
                <input
                  className="invoice-input"
                  name="invoice_total_sum_price_with_vat"
                  type="text"
                  value={sumValues?.invoice_total_sum_price_with_vat}
                  onChange={(e) => handleOnChangeSumValues(e)}
                  onKeyDown={handleKeyDown}
                  disabled={!isOwner}
                />
              </div>
            </li>
            <li className="list-group-item row d-flex border-0">
              <div className="col-xl-6 col-md-4">
                <div className="fs14 text-gray-e py-2">
                  {t("CalculatedTotalSum")}:
                </div>
              </div>
              <div className="col-xl-3 col-md-4 col-6 col-sm-6 text-end pe-0">
                <input
                  className="invoice-input"
                  name="calculated_total_sum"
                  value={calculateTotalSum()}
                  disabled
                />
              </div>
              <div className="col-xl-3 col-md-4 col-6 col-sm-6 d-flex d-md-block text-end">
                <input
                  className="invoice-input"
                  name="calculated_total_sum_manual"
                  type="text"
                  value={sumValues?.calculated_total_sum_manual}
                  onChange={(e) => handleOnChangeSumValues(e)}
                  onKeyDown={handleKeyDown}
                  disabled={!(isOwner && isSumManual)}
                />
                <img
                  src={edit}
                  alt="edit"
                  className={`ml10 ps-1 mt-0 ${
                    !isOwner ? "is_disabled" : "cursor-pointer"
                  }`}
                  onClick={(e) => handleSwitchManualSum()}
                />
              </div>
            </li>
            <li className="list-group-item row d-flex border-0">
              <div className="col-lg-6 col-md-6">
                <div className="fs14 text-gray-e py-2">
                  {t("TotalDiscountAmount")}:
                </div>
              </div>
              <div className="col-md-6 col-8 text-end pr45">
                <input
                  className="invoice-input discount-invoice-input"
                  name="total_discount_amount"
                  type="text"
                  value={sumValues?.total_discount_amount}
                  onChange={(e) => handleOnChangeSumValues(e)}
                  onKeyDown={handleKeyDown}
                  disabled={!isOwner}
                />
              </div>
            </li>
            <li className="list-group-item row d-flex border-0">
              <div className="col-xl-6 col-md-4 col-12">
                <div className="fs14 text-gray-e py-2 poppins-semibold text-lg-nowrap">
                  {t("CalculatedTotalSumAfterDiscount")}:
                </div>
              </div>
              <div className="col-xl-3 col-md-4 col-6 col-sm-6 text-end pe-0">
                <input
                  className="invoice-input discount-invoice-input poppins-semibold"
                  name="calculated_total_sum_after_discount"
                  type="number"
                  value={(
                    (calculateTotalSum() - Math.abs((parseFloat(sumValues?.total_discount_amount) || 0)) || 0)
                  ).toFixed(2)}
                  disabled
                />
              </div>
              <div className="col-xl-3 col-md-4 col-6 col-sm-6 d-flex d-md-block text-end align-items-center">
                <input
                  className="invoice-input discount-invoice-input poppins-semibold"
                  name="calculated_total_sum_after_discount_manual"
                  type="text"
                  value={sumValues?.calculated_total_sum_after_discount_manual}
                  onChange={(e) => handleOnChangeSumValues(e)}
                  onKeyDown={handleKeyDown}
                  disabled={!(isOwner && isSumManual)}
                />
                <span>
                  <img
                    src={edit}
                    alt="edit"
                    className={`ml10 ps-1 mt-0 ${
                      !isOwner ? "is_disabled" : "cursor-pointer"
                    }`}
                    onClick={(e) => handleSwitchManualSum()}
                  />
                </span>
                <div className="col-md-4 col-12 text-md-center text-start">
                  {/* {isSumManual ? "Manual" : "Auto"} */}
                </div>
              </div>
            </li>
          </ul>
        </div>
      ),
    },
  ];

  const treatments = invoiceData?.extracted_invoice_data[
    selectedPage - 1
  ]?.treatments?.map((item, index) => {
    return {
      key: item.key,
      label: (
        <div className="d-flex justify-content-between">
          <div className="d-flex align-items-center">
            <span className="dark-text fs18 poppins-medium d-inline-block pl25">
              {t("treatment")} <span className="ms-1 poppins-medium">{index + 1}</span>
            </span>
            <span className="dotgray ms-2">{item.Items?.length}</span>
          </div>
          <div className="">
            <Tooltip title={t("deleteTreatment")} placement="bottom">
              <img
                src={trash}
                alt="delete"
                className={`${
                  isOwner ? "cursor-pointer" : "is_disabled"
                } dotgray rounded-circle pt7 pb7 pl9 pr9`}
                onClick={() => {
                  handleConfirmationPopup("treatment", item.key);
                }}
              />
            </Tooltip>
          </div>
        </div>
      ),
      children: (
        <div>
          <div className="row mt15 treatment-collapse">
            <div className="col-md-4 invoice-date">
              <label className="time-gray fs12 poppins-medium mb5">
                {t("petName")}
              </label>
              <Input
                name="Pet Name"
                value={item["Pet Name"]}
                placeholder={t("petName")}
                onChange={(e) =>
                  updateTreatmentContent(
                    item.key,
                    null,
                    e.target.name,
                    e.target.value
                  )
                }
                className={
                  item["Pet Name"]?.trim() === "" || item["Pet Name"] === null
                    ? "bg-invoiceorange"
                    : ""
                }
                disabled={!isOwner}
              />{" "}
            </div>
            <div className="col-md-4 col-12">
              <label className="time-gray fs12 poppins-medium mb5">
                {t("treatmentDate")}
              </label>
              <Input
                name="Treatment Date"
                value={item["Treatment Date"]}
                placeholder={t("treatmentDate")}
                onChange={(e) =>
                  updateTreatmentContent(
                    item.key,
                    null,
                    e.target.name,
                    e.target.value
                  )
                }
                className={
                  item["Treatment Date"]?.trim() === "" ||
                  item["Treatment Date"] === null
                    ? "bg-invoiceorange"
                    : ""
                }
                disabled={!isOwner}
              />{" "}
            </div>
            <div className="col-md-4 col-12">
              <label className="time-gray fs12 poppins-medium mb5">
                {t("diagnosis")}
              </label>
              <Input
                name="Diagnose"
                value={item["Diagnose"]}
                placeholder={t("diagnosis")}
                onChange={(e) =>
                  updateTreatmentContent(
                    item.key,
                    null,
                    e.target.name,
                    e.target.value
                  )
                }
                className={
                  item["Diagnose"]?.trim() === "" || item["Diagnose"] === null
                    ? "bg-invoiceorange"
                    : ""
                }
                disabled={!isOwner}
              />
            </div>
          </div>
          <div className="mt15 treatment-collapse-details">
            <div className="row d-none d-md-flex">
              <div className="col-md-6">
                <span className="time-gray fs12 poppins-medium mb5 d-inline-block pl25">
                  {t("itemName")}
                </span>
              </div>
              <div className="col-md-6">
                <div className="row">
                 <div className="col-md-11">
                   <div className="row">
                     <div className="col-md-4">
                      <span className="time-gray fs12 poppins-medium mb5 d-inline-block">{t("quantity")}</span>
                     </div>
                     <div className="col-md-4">
                      <span className="time-gray fs12 poppins-medium mb5 d-inline-block">{t("prize")}</span>
                     </div>
                     <div className="col-md-4">
                      <span className="time-gray fs12 poppins-medium mb5 d-inline-block">{t("VAT")}</span>
                     </div>
                   </div>
                  </div>
                 <div className="col-md-1">
                 </div>
                </div>
               </div>
            </div>

            <LineItem
              treatments={item}
              treatmentId={item.key}
              handleConfirmationPopup={handleConfirmationPopup}
              handleOnChangeItem={updateTreatmentContent}
              isEdit={!isOwner}
              selectedPage={selectedPage}
              treatmentIndex= {index}
              extracted_invoice_data = {invoiceData.extracted_invoice_data}
            />
          </div>
          <div className="row mt15 mb10">
            <div className="col-sm-6 col-4">
              <button
                onClick={() => addItemToTreatment(item.key)}
                className="fill-primary"
                disabled={!isOwner}
              >
                {t("addItem")}
              </button>
            </div>
            <div className="col-sm-6 col-8">
              <div className="outline-primary text-blue-a bg-transparent pe-none pl10 pr10 d-flex align-items-center justify-content-between">
                <div className="poppins-medium">{t("subTotal")}:</div>
                <div className="poppins-medium">
                  {calculateSubTotal(item)}
                </div>
              </div>
            </div>
          </div>
        </div>
      ),
    };
  });

  return (
    <>
      <Spin spinning={loading} size="large">
        <div>
          <div className="row flex-wrap-reverse mx-0">
            <div className="col-lg-7 pt30 pl30 pe-0 bg-white invoice-view">
               <span
                  onClick={handleOnBack}
                  className="handle-add-treatment-btn mb-1 d-inline-block"
                >
                  <img
                    src={backarrow}
                    alt="arrow"
                    className="me-2 back-arrow"
                  />
                  {t("back")}
                </span>
              <div className="col-md-12 d-flex align-items-center page-footer mar-b-0 pad-l-0 bg-white justify-content-between flex-wrap flex-md-nowrap pr30 mb20">
                <span className="dark-text fs26 poppins-semibold">
                  {t("details")}
                </span>
                <div className="d-flex align-items-center flex-wrap flex-md-nowrap gap10">
                  <Tooltip title={t("addTreatment")} placement="bottom">
                    <button disabled={!isOwner}
                    className="circle-btn ml10" onClick={addTreatment}><img
                      src={addTreatmentIcon}
                      alt="notes"
                    /></button>
                  </Tooltip>
                  <Tooltip title={t("notes")} placement="bottom">
                    <img
                      src={notes ? InvoicenotesCompleted : Invoicenotes}
                      alt="notes"
                      className="ml10 cursor-pointer"
                      onClick={openNotesModel}
                    />
                  </Tooltip>
                  <img
                    src={Invoiceedit}
                    alt="edit"
                    className={`ml10 ${
                      !isOwner && "is_disabled"
                    }`}
                    onClick={handleExcelDownload}
                  />
                </div>
              </div>
              <div
                className={`parent-div-invoice ${
                  isCollapseActive ? "active" : ""
                }`}
              >
                <div className="my-0 collapse-invoice pr30 pad-r-15">
                  <Collapse
                    defaultActiveKey={["1"]}
                    items={general_information}
                    collapsible="header"
                    expandIconPosition="end"
                    expandIcon={({ isActive }) => (
                      <img src={isActive ? uparrow : downarrow} alt="drop" />
                    )}
                  />
                </div>
                <DragDropContext onDragEnd={onDragEnd}>
                  <Droppable droppableId="droppable" type="treatment">
                    {(provided) => (
                      <div ref={provided.innerRef} className="treatement-table pr30">
                        {treatments &&
                          treatments?.map((item, index) => (
                            <Draggable
                              key={String(item.key)}
                              draggableId={String(item.key)}
                              index={index}
                              isDragDisabled={!isOwner}
                            >
                              {(provided, snapshot) => (
                                <div
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  style={getItemStyle(
                                    snapshot.isDragging,
                                    provided.draggableProps.style
                                  )}
                                >
                                  <div className="position-relative">
                                    <span className="drag-icon" {...provided.dragHandleProps}>
                                      <img
                                        src={drag}
                                        alt="Drag"
                                        className=""
                                      />
                                    </span>
                                    <div className="collapse-item">
                                      <Collapse
                                        key={String(item.key)}
                                        defaultActiveKey={["1"]}
                                        collapsible="header"
                                        items={[item]}
                                        expandIconPosition="end"
                                        expandIcon={({ isActive }) => (
                                          <img
                                            src={isActive ? uparrow : downarrow}
                                            alt={"drop"}
                                          />
                                        )}
                                      />
                                    </div>
                                  </div>
                                </div>
                              )}
                            </Draggable>
                          ))}
                        {provided.placeholder}
                      </div>
                    )}
                  </Droppable>
                </DragDropContext>
              </div>
              <CustomModal
                visible={confirmationPopup.isShow}
                modalTitle={confirmationPopup.type}
                handleConfirm={handleOnDeleteConfirmation}
                handleCancel={handleOnDeleteCancel}
                buttonName={buttonName}
                assignedTo={confirmationPopup.assigned_to}
              />

              <div className="page-footer pb20 pt20 pad-l-0">
                <div className="my-0 collapse-footer mr40">
                  <Collapse
                    defaultActiveKey={["1"]}
                    items={calculate_discount}
                    collapsible="header"
                    expandIconPosition="end"
                    expandIcon={({ isActive }) => (
                      <img src={isActive ? uparrow : downarrow} alt="drop" />
                    )}
                    onChange={(keys) => {
                      toggleCollapse(keys);
                    }}
                  />
                </div>
                <div className="d-flex flex-wrap flex-sm-nowrap invoice-submit-btn gap-3 pr40 pad-r-0">
                  <CustomButton
                    label={t("reset")}
                    type="primary"
                    htmlType="submit"
                    className="outline-secondary"
                    navigate={false}
                    onClick={(e) =>
                      handleConfirmationPopup("reset", null, null)
                    }
                    span_className="fs14"
                    disabled={!isOwner}
                  />
                  <CustomButton
                    label={t("resetInitial")}
                    type="primary"
                    htmlType="submit"
                    className="outline-secondary"
                    navigate={false}
                    onClick={(e) =>
                      handleResetConfirmationPopup("resetToInitial", null, null)
                    }
                    span_className="fs14"
                    disabled={!isOwner}
                  />
                  <CustomButton
                    label={isOwner ? t("revoke") : t("assign")}
                    type="primary"
                    htmlType="submit"
                    className="outline-secondary"
                    navigate={false}
                    onClick={handleOnClickAssign}
                    span_className="fs14"
                  />
                  <CustomButton
                    label={t("update")}
                    type="primary"
                    htmlType="submit"
                    className="outline-primary"
                    navigate={false}
                    onClick={(e) => handleOnUpdate(invoiceData, sumValues)}
                    span_className="fs14"
                    disabled={!isOwner}
                  />
                </div>
              </div>
            </div>
            <div className="col-lg-5 bg-view px-0">
              <h1 className="fs16 poppins-medium text-gray-e mt35 mb15 ml35 mar-l-15 mar-t-20">
                {invoiceData?.file_name || "Document name"}
              </h1>
              {images?.length && (
                <ImageList
                  imageList={images}
                  current={images[selectedPage - 1].image_url}
                  onChange={handleOnChangePage}
                  currentIndex={selectedPage}
                />
              )}
            </div>
          </div>
        </div>

        <Modal
          title={t("notes")}
          open={isNotesModalVisible}
          onOk={handleNotesModalOk}
          onCancel={handleNotesModalCancel}
          centered
          footer={null}
          className="notes-modal"
          width={512}
        >
          <img
            src={modalNote}
            alt="notes"
            className="modal-head-icon"
          />
          <div className="time-gray fs12 poppins-medium mb5">
            {t("comment")}
          </div>
          <Input.TextArea
            value={notes}
            onChange={handleNotesChange}
            placeholder={t("enter_notes")}
            autoSize={{ minRows: 5, maxRows: 12 }}
          />
          <div className="footer-modal d-flex gap-3 mt-2">
            <CustomButton
              label={t("cancel")}
              type="primary"
              htmlType="submit"
              className="btn-white w-100 br8 h38"
              navigate={false}
              key="reset"
              onClick={handleNotesModalCancel}
            />
            <CustomButton
              label={t("add")}
              type="primary"
              htmlType="submit"
              className="btn-blue w-100 br8 h38"
              navigate={false}
              key="add"
              onClick={handleNotesModalOk}
            />
          </div>
        </Modal>
      </Spin>
    </>
  );
};
export default Invoice;
